import { render, staticRenderFns } from "./ModalChangePassword.vue?vue&type=template&id=1da899d2"
import script from "./ModalChangePassword.vue?vue&type=script&lang=js"
export * from "./ModalChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports